import {Injectable} from '@angular/core';
import {SearchState} from '../../../types/SearchState';

@Injectable()
export class StateValidatorService {
  constructor() {}

  public isStateValuesValid(state: SearchState): boolean {
    let isValid: boolean = true;
    if (
      state.caregiverUnitTypeUrlPath === '' &&
      state.careServiceTypeUrlPath === '' &&
      state.symptomUrlPath === '' &&
      state.placeUrlPath === '' &&
      state.freeSearchTerm === ''
    ) {
      isValid = false;
    }
    return isValid;
  }
}
